// cfgreftables

const mutations = {
	getCfgRefTables(state, objects) {
		state.cfgreftables = objects;
  	},

};

export default mutations;